export default class LocalStorageApiAuth {
    constructor(storageKey = 'auth_token') {
        this.storageKey = storageKey;
    }

    getToken() {
        return localStorage.getItem(this.storageKey);
    }

    setToken(token) {
        localStorage.setItem(this.storageKey, token);
    }

    removeToken() {
        localStorage.removeItem(this.storageKey);
    }
}